import React from "react";
import Footer from "./common/Footer";
import Nav from "./common/Nav";
import LocationImg from "./img/location-img.jpg";

const MovingTips = () => {
    return (
        <div>
            <Nav />
            <section className="brdcrm">
                <h2>Moving Tips</h2>
            </section>

            <section className="about_section">
                <div className="container">
                    <div className="text-center">
                        <img src={LocationImg} className="w-100" />
                    </div>
                    <h3>Ultimate Packing & Moving Tips for a Stress-Free Relocation</h3>
                    <br />
                    <div className="row">
                        <div className="col-lg-6">
                            <h5>Pre-Move Preparation</h5>
                            <ul>
                                <li>Create a moving checklist to stay organized.</li>
                                <li>Declutter and donate to lighten your load.</li>
                                <li>Gather essential packing supplies.</li>
                                <li>Label boxes clearly for easy unpacking.</li>
                                <li>Notify important parties of your address change.</li>
                            </ul>
                        </div>
                        <div className="col-lg-6">
                            <h5>Packing Tips</h5>
                            <ul>
                                <li>Pack room by room to stay organized.</li>
                                <li>Use appropriate box sizes for different items.</li>
                                <li>Wrap fragile items securely.</li>
                                <li>Seal liquids to prevent leaks.</li>
                                <li>Keep essentials separate for easy access.</li>
                            </ul>
                        </div>
                        <div className="col-lg-6">
                            <h5>Moving Day Tips</h5>
                            <ul>
                                <li>Start early to manage last-minute tasks.</li>
                                <li>Hire professional movers for efficiency.</li>
                                <li>Keep valuables with you at all times.</li>
                                <li>Do a final walkthrough before leaving.</li>
                                <li>Stay hydrated and take breaks.</li>
                            </ul>
                        </div>
                        <div className="col-lg-6">
                            <h5>Post-Move Organization</h5>
                            <ul>
                                <li>Unpack essentials first.</li>
                                <li>Assemble furniture before unpacking small items.</li>
                                <li>Break down and recycle boxes.</li>
                                <li>Inspect items for damage.</li>
                                <li>Take your time settling in.</li>
                            </ul>
                        </div>
                    </div>

                </div>
            </section>
            <Footer />
        </div>
    );
}

export default MovingTips;